import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
} from '@angular/core';
import { List } from 'immutable';
import { PayPalTransactionItem } from '../../../payments-data/payments-data.data';
import { PaymentsDataStore } from '../../../payments-data/payments-data.store';
import { Observable } from 'rxjs/internal/Observable';
import { debounce } from '../../../shared/decorators/debounce.decorator';
import { PaymentsDataDispatcher } from '../../../payments-data/payments-data.dispatcher';
import { filter, take, withLatestFrom } from 'rxjs/operators';

@Component({
  selector: 'app-paypal-transactions-history-dialog',
  templateUrl: './paypal-transactions-history-dialog.component.html',
  styleUrls: ['./paypal-transactions-history-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayPalTransactionsHistoryDialogComponent implements OnInit {
  transactions$: Observable<List<PayPalTransactionItem>>;
  loading$: Observable<boolean>;
  nextPageTimestamp$: Observable<string>;

  @debounce(250)
  onScroll(event: any) {
    // visible height + pixel scrolled >= total height
    if (
      event.target.offsetHeight + event.target.scrollTop >=
      event.target.scrollHeight
    ) {
      this.fetchMoreTransactions();
    }
  }

  constructor(
    private _paymentsDataStore: PaymentsDataStore,
    private _paymentsDataDispatcher: PaymentsDataDispatcher,
    private _elRef: ElementRef
  ) {}

  ngOnInit() {
    this.transactions$ = this._paymentsDataStore.payPalTransactionHistory$;
    this.loading$ = this._paymentsDataStore.loadingPayPalTransactionHistory$;
    this.nextPageTimestamp$ = this._paymentsDataStore.payPalTransactionHistoryNextPageTimestamp$;
  }

  fetchMoreTransactions() {
    this.nextPageTimestamp$
      .pipe(
        filter((x) => !!x?.trim()),
        take(1),
        withLatestFrom(this.loading$),
        filter(([_, loading]: [string, boolean]) => !loading)
      )
      .subscribe(([timestamp, _]: [string, boolean]) => {
        this._paymentsDataDispatcher.fetchPayPalTransactionHistory(timestamp);
      });
  }
}
